import axios from "axios";

// Use a relative /api path so the frontend works on any domain
// (custom domain, preview, production) via the same-origin ingress routing.
// REACT_APP_BACKEND_URL is only used as a fallback for non-browser environments.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API =
  typeof window !== "undefined" && window.location && window.location.origin
    ? "/api"
    : `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "AED", symbol: "AED", name: "UAE Dirham" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
];

export function currencySymbol(code) {
  return (CURRENCIES.find((c) => c.code === code) || { symbol: code }).symbol;
}

export function fmtMoney(n, code = "USD") {
  const sym = currencySymbol(code);
  const v = Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
  return `${sym}${v}`;
}
